import { RegistryItem } from "@schemas/agreements/schema";
import { AgreementTypeEnum } from "__generated__/graphql";

export const HoseRentalSchema: RegistryItem = {
	[AgreementTypeEnum.HoseRental]: {
		agreementFields: {
			"agreement.costType": { rules: { hidden: true } },
			"agreement.description": { rules: { hidden: true } },
		},
	},
};
